/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class PJMDayAheadPrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "PJMDayAheadPrices";
}

const servicePlugin = makeServicePlugin({
  Model: PJMDayAheadPrices,
  service: feathersClient.service("data-services/pjm/day-ahead-locational-marginal-prices"),
  idField: "Bus Name",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
